import paymentOptionListStore from '@modules/payment-option/payment-option-list-store';
import paymentOptionViewStore from '@modules/payment-option/payment-option-view-store';
import paymentOptionImporterStore from '@modules/payment-option/payment-option-importer-store';
import paymentOptionFormStore from '@modules/payment-option/payment-option-form-store';
import paymentOptionDestroyStore from '@modules/payment-option/payment-option-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: paymentOptionDestroyStore,
    form: paymentOptionFormStore,
    list: paymentOptionListStore,
    view: paymentOptionViewStore,
    importer: paymentOptionImporterStore,
  },
};
